module.exports = __webpack_public_path__ + "img/ico_new2.2e5b4ac4.svg";